import { Injectable } from '@angular/core';

import { Selector, StateContext, Action, State } from '@ngxs/store';
import { Reservation } from 'rest-client';

import {
  SetReservationAction,
  RemoveReservationAction,
} from './reservation.actions';
import { ReservationStateModel } from './reservation.model';

@State<ReservationStateModel>({
  name: 'reservation',
  defaults: new Reservation(),
})
@Injectable()
export class ReservationState {
  @Selector()
  static reservationData(state: ReservationStateModel): ReservationStateModel {
    return state;
  }

  @Action(SetReservationAction)
  setReservationAction(
    ctx: StateContext<ReservationStateModel>,
    action: SetReservationAction
  ): void {
    ctx.patchState(action.reservation);
  }

  @Action(RemoveReservationAction)
  removeReservationAction(ctx: StateContext<ReservationStateModel>): void {
    ctx.setState(new Reservation());
  }
}
